import defaultValue from "./PeopleSlice";

export default defaultValue;
export * from "./PeopleSlice";
export * from "./PeopleSlice.types";
